import { Trans } from '@lingui/react/macro';

import Badge from '@/design_system/Badge';
import IconStar from '@/icons/Star.svg';
import useViewPort from '@/utils/useViewport';

export const OfficialBadge = () => {
  const { isMobile, isTablet } = useViewPort();

  return (
    <Badge size="small" color="neutral-reversed" borderRadius="soft" hasBorder>
      <IconStar filled style={{ color: 'var(--color-warning-500)' }} />
      {!isMobile && !isTablet && <Trans id="components.workshop-list.official">Official</Trans>}
    </Badge>
  );
};
